// import { Typography, Card } from '@mui/material';
// import CardMedia from '@mui/material/CardMedia';
// import CardContent from '@mui/material/CardContent';

const cardStyle = {
  width: '333px',
  background: '#FAFAFA',
  boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.1)',
  borderRadius: '10px',
  p: '30px',
  m: '10px',
  cursor: 'pointer',
  transition: '0.2s ease-in-out',
  ':hover': {
    backgroundColor: '#e3f2fd',
    transform: 'scale(1.05)',
  },
  '@media(max-width: 768px)': {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const AnalyticsCard = ({ img, title, description, openAnalyticsDrawer }) => {
  return (
    <div
      onClick={openAnalyticsDrawer}
      className="max-w-sm text-center hover:bg-muted cursor-pointer rounded-lg p-4 border"
    >
      <img src={img} className="w-[140px] mx-auto" />
      <div>
        <div className="text-xl font-semibold">{title}</div>
        <div className="text-sm text-muted-foreground">{description}</div>
      </div>
    </div>
  );
};

export default AnalyticsCard;
